module.exports = __webpack_public_path__ + "img/cat.3eaad6ff.svg";